import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import './index.css'
import { queryClient } from './lib/queryClient'
import { loadGoogleTag } from './lib/googleAds'
import { GoogleAnalyticsPageViews } from './lib/googleAnalytics'
import { initializeTheme } from './lib/theme'

initializeTheme()
loadGoogleTag()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <GoogleAnalyticsPageViews />
      <App />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </BrowserRouter>
  </QueryClientProvider>,
)
